var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitChildrens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exit_Children_s",
    "data-name": "Exit Children\\u2019s",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 169)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "exit",
    transform: "translate(476 190)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 4.466,
    cy: 4.466,
    r: 4.466,
    transform: "translate(15.397 8.122)",
    fill: "none",
    stroke: "#2563eb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9846",
    "data-name": "Path 9846",
    d: "M12.971,36.969V30L6.744,24.533a2.057,2.057,0,0,1-.587-2.372l3.576-8.582",
    transform: "translate(2.971 7.858)",
    fill: "none",
    stroke: "#2563eb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9847",
    "data-name": "Path 9847",
    d: "M3.743,18.223c1.976-4.774,8.5-7.025,15.685-3.486,3.123,5.047,6.863,3.74,8.714,1.743m-12.2,6.971,3.486-8.714M2,32.166H7.228l4.807-4.807m30.05-7.393H33.371M38.6,14.738l5.228,5.228L38.6,25.195",
    transform: "translate(0 7.433)",
    fill: "none",
    stroke: "#2563eb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9848",
    "data-name": "Path 9848",
    d: "M20,18.685V3H35.685V48.313H20v-12.2",
    transform: "translate(13.371 0)",
    fill: "none",
    stroke: "#2563eb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitChildrens);
export default __webpack_public_path__ + "static/media/ExitChildrens.7ab75c848090e1a08fc9d4704dc8d97d.svg";
export { ForwardRef as ReactComponent };